import React, { useContext, useState } from 'react';
import { AccountManagementContext } from '../../../../context/AccountManagementContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { formatDateTime } from '../../../../utils/dateTimeFormate';
import AssignUsersModal from './AssignUsersModal';
import { Link } from 'react-router-dom';
import { useDeleteHandler } from '../../../../hooks/useDeleteHandler';
import { DeleteRole } from '../../../../services/adminApiService/accountManagementApi/AccountManagementApiService';

const AccountRoleManagementList = ({ debouncedSearchValue, currentPage, perPage }) => {
    const { loading, RoleAccountList, setShowCreateModal, setEditData, fetchRoleAccountManagementList, fetchDeleteAccountuser } = useContext(AccountManagementContext);
    const [showModal, setShowModal] = useState(false);
    const { handleDelete } = useDeleteHandler();
    // ✅ DELETE HANDLER USING HOOK
    const deleteHandler = (id) => {
        handleDelete({
            deleteApi: DeleteRole,
            id,
            refreshListApi: () =>
                fetchRoleAccountManagementList(),
            // successMsg: "Role deleted successfully"
        });
    };
    const [sortColumn, setSortColumn] = useState(null);
    const [selectedRoleId, setSelectedRoleId] = useState(null); // holds active sort column
    const [sortAsc, setSortAsc] = useState(true); // holds direction
    const handleSort = (key) => {
        const isSameColumn = sortColumn === key;
        const newSortAsc = isSameColumn ? !sortAsc : true; // if clicking again toggle, else default to asc
        setSortColumn(key);
        setSortAsc(newSortAsc);
        fetchRoleAccountManagementList(key, newSortAsc ? "asc" : "desc");
    };
    
    return (
        <>
            <div className="card-body">
                {loading ? (
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="w-100 table-responsive">
                        <div id="example_wrapper" className="dataTables_wrapper">
                            <table id="example" className="display w-100 dataTable">
                                <thead>
                                    <tr>
                                        {/*<th>SN</th>*/}
                                        <th
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleSort("id")}
                                        >
                                            ID
                                            {sortColumn === "id" ? (sortAsc ? "⬆" : "⬇") : "⬆⬇"}
                                        </th>
                                        <th>Roles</th>
                                        <th>Created On</th>
                                        <th>Users Assigned</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {RoleAccountList?.data?.data?.length > 0 ? (
                                        RoleAccountList?.data?.data?.map((data, index) => {
                                            // console.log("data------------>",data?.user_added_by)

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1 + (currentPage - 1) * perPage}</td>
                                                    <td>{data?.role_name}</td>
                                                    <td>{formatDateTime(data?.created_at)}</td>

                                                    <td>
                                                        {data?.users_assigned > 0 ? (
                                                            <a
                                                                href={`/account/role-assign/${data?.id}`}
                                                                style={{ color: "#0d6efd", textDecoration: "none" }}
                                                            >
                                                                {data?.users_assigned}
                                                                <span className="mx-2">
                                                                    <i className="bi bi-eye"></i>
                                                                </span>
                                                            </a>
                                                        ) : (
                                                            <span
                                                                style={{
                                                                    color: "#6c757d",
                                                                    cursor: "not-allowed",
                                                                    opacity: 0.6,
                                                                }}
                                                            >
                                                                {data?.users_assigned}
                                                                <span className="mx-2">
                                                                    <i className="bi bi-eye"></i>
                                                                </span>
                                                            </span>
                                                        )}
                                                    </td>

                                                    <td
                                                        style={{ cursor: "pointer" }}

                                                    >
                                                        {data?.user_added_by === "module" ? <h5>Managed By Module</h5> :
                                                         <div className="d-flex ">
                                                            <div className="icon_wrapper"
                                                                onClick={() => {
                                                                    setSelectedRoleId(data?.id);
                                                                    setShowModal(true);
                                                                }}
                                                            >
                                                                <i className="bi bi-person"></i>
                                                            </div>
                                                            <Link to={`/account/role/update/${data?.id}`}>
                                                                <div className="icon_wrapper mx-2"

                                                                >
                                                                    <i className="bi bi-pencil"></i>
                                                                </div>
                                                            </Link>


                                                            <div className="icon_wrapper mx-2 " onClick={() => deleteHandler(data?.id)}><RiDeleteBinLine className="text-danger" /></div>


                                                        </div>
                                                        }
                                                       

                                                    </td>
                                                    {/* <td>{formatDateTime(data?.created_at)}</td> */}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                Data is not available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
            <AssignUsersModal
                show={showModal}
                roleId={selectedRoleId}
                handleClose={() => {
                    setShowModal(false);
                    setSelectedRoleId(null);
                }}
                debouncedSearchValue={debouncedSearchValue}
                perPage={perPage}
                currentPage={currentPage}
            />

        </>
    );
}

export default AccountRoleManagementList;

